/* THIS FILE IS GENERATED ON RUNTIME. DO NOT EDIT */

import { ComponentClassNameFactory } from 'lib/contexts/ComponentClassNameFactory';
import { getPropStylesFactory } from '@/utils/getPropStylesFactory';
import { getComponentStylesFactory } from '@/utils/getComponentStylesFactory';
import { getComponentThemeFactory } from '@/utils/getComponentThemeFactory';
import make_styler from '../index';

export const styles = {
  "headline_variant_default": "",
  "headline_colors_primary": "",
  "headline_size_default": "text-headline-lg sm:text-headline-2xl mb-2",
  "description_variant_default": "",
  "description_colors_primary": "",
  "description_size_default": "text-body-sm sm:text-body-md mb-6 max-w-article",
  "article_group_variant_default": "grid grid-cols-3 gap-3",
  "article_group_colors_primary": "",
  "article_group_size_default": "pb-3",
  "article_headline_variant_default": "hidden",
  "article_headline_colors_primary": "",
  "article_headline_size_default": "",
  "article_image_variant_default": "",
  "article_image_colors_primary": "",
  "article_image_size_default": "",
  "article_variant_default": "",
  "article_colors_primary": "",
  "article_size_default": "",
  "variant_default": "max-w-[980px] mx-auto",
  "colors_primary": "",
  "size_default": "pt-3 py-6"
};

const c = make_styler(styles);

export const propClassName = getPropStylesFactory(c, styles, "InstagramArticlesList");

export const componentClassName = getComponentStylesFactory(propClassName);

export const componentTheme = getComponentThemeFactory(styles);

export const {
  ClassNameContext,
  ClassNameProvider,
  useClassName,
  useTheme,
} = ComponentClassNameFactory(componentClassName, styles);
  
export default c;